import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import styled from "styled-components"

import {
    LANG_EN,
    LANGUAGES,
    LOCAL_STORAGE_LANG_ID,
    LOCAL_STORAGE_LANG_REPORT_ID,
} from "const"
import { LangIndex } from "client/utils"
import {
    StoreType,
    LoadLang,
    setSystemLang,
    setSystemLangReport,
} from "client/store"
import {
    FormGroup,
    Label,
    SelectDropdown,
    SelectDropdownItem,
} from "client/components"


// system lang switcher

const SelectDropdownHeader = styled(SelectDropdown)`
    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        height: 63px;
        width: 50px;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
        font-family: ${(props) => props.theme.openSans};
        background: ${(props) => props.theme.headerBackground} !important;
        color: ${(props) => props.theme.defaultTextColor};

        &::after {
            display: none;
        }
    }

    .dropdown-menu {
        width: fit-content;
        overflow: auto;

        & > a {
            padding: 6px 12px;
            text-transform: uppercase;
            text-align: center;
            font-weight: 600;
            font-family: ${(props) => props.theme.openSans};
        }
    }
`

export const LangSwitcher = () => {
    const [langId, setLangId] = useState<LangIndex>(null)
    const dispatch = useDispatch()

    useEffect(() => {
        let langIndex = window.localStorage.getItem(LOCAL_STORAGE_LANG_ID) as LangIndex
        if (!langIndex || !LANGUAGES.includes(langIndex)) langIndex = LANG_EN
        setLangId(langIndex)
    }, [])

    const changeLang = (langIndex: LangIndex) => {
        LoadLang(langIndex).then((res) => {
            dispatch(setSystemLang(res))
            setLangId(langIndex)
            window.localStorage.setItem(LOCAL_STORAGE_LANG_ID, langIndex)
        })
    }

    return (
        <SelectDropdownHeader title={langId || ""}>
            {
                LANGUAGES.map((row) => {
                    const langIndex = row as LangIndex
                    return (
                        <SelectDropdownItem
                            key={langIndex}
                            onClick={() => changeLang(langIndex)}
                        >
                            {langIndex}
                        </SelectDropdownItem>
                    )
                })
            }
        </SelectDropdownHeader>
    )
}


// report lang switcher

const SelectDropdownReport = styled(SelectDropdown)`
    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        height: 38px;
        width: fit-content;
        margin-bottom: 0;
        padding: 4px 30px 6px 12px;
        text-transform: uppercase;
        font-weight: 600;
        font-family: ${(props) => props.theme.openSans};
        color: ${(props) => props.theme.defaultTextColor};

        &::after {
            border-top-color: ${(props) => props.theme.defaultTextColor};
        }
    }

    .dropdown-menu {
        width: fit-content;
        overflow: auto;

        & > a {
            padding: 6px 12px;
            text-transform: uppercase;
            text-align: center;
            font-weight: 600;
            font-family: ${(props) => props.theme.openSans};
        }
    }
`
const FormGroupStyled = styled(FormGroup)`
    margin-bottom: 0;
    margin-right: 5px;
`
const LabelStyled = styled(Label)`
    margin-bottom: 0;
`
export const LangReportWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

export const LangReportSwitcher = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [langId, setLangId] = useState<LangIndex>(null)
    const dispatch = useDispatch()

    useEffect(() => {
        let langIndex = window.localStorage.getItem(LOCAL_STORAGE_LANG_REPORT_ID) as LangIndex
        if (!langIndex || !LANGUAGES.includes(langIndex)) langIndex = LANG_EN
        setLangId(langIndex)
    }, [])

    const changeLang = (langIndex: LangIndex) => {
        LoadLang(langIndex).then((res) => {
            dispatch(setSystemLangReport(res))
            setLangId(langIndex)
            window.localStorage.setItem(LOCAL_STORAGE_LANG_REPORT_ID, langIndex)
        })
    }

    return (
        <FormGroupStyled inline>
            <LabelStyled>{lang.reportLanguage}</LabelStyled>
            <SelectDropdownReport title={langId || ""}>
                {
                    LANGUAGES.map((row) => {
                        const langIndex = row as LangIndex
                        return (
                            <SelectDropdownItem
                                key={langIndex}
                                onClick={() => changeLang(langIndex)}
                            >
                                {langIndex}
                            </SelectDropdownItem>
                        )
                    })
                }
            </SelectDropdownReport>
        </FormGroupStyled>
    )
}
